import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=216bbda0&scoped=true"
import script from "./PermissionModal.vue?vue&type=script&lang=js"
export * from "./PermissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216bbda0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216bbda0')) {
      api.createRecord('216bbda0', component.options)
    } else {
      api.reload('216bbda0', component.options)
    }
    module.hot.accept("./PermissionModal.vue?vue&type=template&id=216bbda0&scoped=true", function () {
      api.rerender('216bbda0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/PermissionModal.vue"
export default component.exports